import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LectureVariantsBase } from '@/components/ui/features/lecture/LectureHeaderSection/components/LectureVariantsBase';
import {
  HeaderLayoutOverlay,
  HeaderLayoutContent,
  HeaderLayoutSidebar,
} from '@/components/ui/features/lecture/LectureHeaderSection/LectureHeaderSection.elements';
import { LectureLanguageDropdown } from '@/components/ui/features/lecture/LectureLanguageDropdown/LectureLanguageDropdown';
import { LecturePlayer } from '@/components/ui/features/lecture/LecturePlayer/LecturePlayer';
import { LecturePlayerTranscript } from '@/components/ui/features/lecture/LecturePlayer/LecturePlayerTranscript';
import { LecturePlayerVideo } from '@/components/ui/features/lecture/LecturePlayer/LecturePlayerVideo';
import { LectureNoContent } from '@/components/ui/features/lecture/LecturePoster/components/LectureNoContent';
import { LecturePosterDropdown } from '@/components/ui/features/lecture/LecturePoster/components/LecturePosterDropdown';
import { LecturePosterPanel, LecturePoster } from '@/components/ui/features/lecture/LecturePoster/LecturePoster';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

export const LectureVariantVideoPoster: FC = () => {
  const { posterExpanded } = useQueryParams<{ posterExpanded: string }>({
    posterExpanded: StringParam,
  });

  const { t } = useTranslation();

  return (
    <LecturePlayer>
      <LectureVariantsBase position="relative">
        <HeaderLayoutOverlay isOpen={posterExpanded === 'true'}>
          <LecturePosterPanel>
            <LecturePoster />
          </LecturePosterPanel>
        </HeaderLayoutOverlay>
        <HeaderLayoutContent>
          <LecturePlayerVideo
            rightAction={<LectureLanguageDropdown label={t('newLecture.transcript')} />}
            leftAction={<LecturePosterDropdown />}
          />
        </HeaderLayoutContent>
        <HeaderLayoutSidebar>
          <LecturePlayerTranscript />
        </HeaderLayoutSidebar>
      </LectureVariantsBase>
    </LecturePlayer>
  );
};

export const LectureVariantVideo: FC = () => {
  return (
    <LecturePlayer>
      <LectureVariantsBase>
        <HeaderLayoutContent>
          <LecturePlayerVideo />
        </HeaderLayoutContent>
        <HeaderLayoutSidebar>
          <LecturePlayerTranscript />
        </HeaderLayoutSidebar>
      </LectureVariantsBase>
    </LecturePlayer>
  );
};

export const LectureVariantPoster: FC = () => {
  return (
    <LectureVariantsBase>
      <HeaderLayoutOverlay isOpen={true}>
        <LecturePoster />
      </HeaderLayoutOverlay>
    </LectureVariantsBase>
  );
};

export const LectureVariantEmpty: FC = () => {
  return (
    <LectureVariantsBase>
      <HeaderLayoutOverlay isOpen={false}>
        <LectureNoContent />
      </HeaderLayoutOverlay>
    </LectureVariantsBase>
  );
};
